import { memo } from 'react'

import { copy } from '~/modules/lunya'
import { PRIVACY_POLICY_URL, TERMS_URL } from '~/shared/config'
import { usePlatform } from '~/shared/platform'
import { Text, TextLink } from '~/shared/ui'

/**
 * Строка акцепта под главной кнопкой первого экрана регистрации.
 *
 * Договор с пользователем заключается акцептом публичной оферты (ст. 435, 437, 438 ГК РФ), и
 * акцепт — это конклюдентное действие: нажатие кнопки. Чтобы нажатие считалось акцептом,
 * человек обязан ДО нажатия видеть, что именно он принимает и где это прочитать, — поэтому
 * строка стоит под кнопкой, а не в профиле потом.
 *
 * ГАЛОЧКИ ЗДЕСЬ НЕТ, И ОНА ЗДЕСЬ ЗАПРЕЩЕНА. Одна галочка «принимаю условия и даю согласие на
 * обработку данных» с 01.09.2025 делает согласие неполученным (ФЗ № 156-ФЗ, docs/legal.md §4.3).
 * Обработка у нас построена на договоре, а не на согласии, и кнопкой принимаются ТОЛЬКО условия;
 * политика названа документом, а не предметом согласия. Тот же запрет — у дисклеймера разборов
 * (`contracts/domain/disclaimer.ts`): галочка превращает уведомление в согласие.
 *
 * Обе ссылки уходят во внешний браузер (`platform.share.openLink`): документ должно быть можно
 * сохранить, переслать и открыть без Telegram — на него смотрят и РКН, и человек с претензией.
 * Мини-аппа при этом остаётся на том же шаге и черновик регистрации не теряет.
 */
export const TermsAcceptNote = memo(function TermsAcceptNote() {
  const platform = usePlatform()
  const { accept } = copy.legal

  return (
    // `as='p'` — это предложение, а не подпись: ссылки живут внутри строки, и обтекание
    // текстом обязано работать. `MUTED` — служебный тон, строка не должна спорить с кнопкой,
    // под которой стоит.
    <Text variant='CAPTION' color='MUTED' align='CENTER' as='p'>
      {accept.before}
      <TextLink
        text={accept.terms}
        variant='CAPTION'
        color='MUTED'
        ariaLabel={copy.legal.terms_doc}
        onPress={() => platform.share.openLink(TERMS_URL)}
      />
      {accept.between}
      <TextLink
        text={accept.policy}
        variant='CAPTION'
        color='MUTED'
        ariaLabel={copy.legal.policy_doc}
        onPress={() => platform.share.openLink(PRIVACY_POLICY_URL)}
      />
      {accept.after}
    </Text>
  )
})
